// extracted by mini-css-extract-plugin
export var actionButton = "_8g-1";
export var actionButtons = "_8g-2";
export var actions = "_8g-0";
export var aiUnread = "_8g-10";
export var alignCenter = "_8g-h";
export var backWrapper = "_8g-3";
export var cellContainer = "_8g-4";
export var checkboxContainer = "_8g-5";
export var contentContainer = "_8g-6";
export var contentHeader = "_8g-8";
export var conversationsTableWrapper = "_8g-s";
export var draftReplyBadgeContainer = "_8g-m";
export var dropdownItem = "_8g-b";
export var dropdownItemsContainer = "_8g-a";
export var dropdownTitle = "_8g-c";
export var errorIcon = "_8g-7";
export var filter = "_8g-d";
export var gray = "_8g-i";
export var headerActionButtons = "_8g-e";
export var headerCheckboxContainer = "_8g-f";
export var icon = "_8g-j";
export var menuContainer = "_8g-k";
export var noMoreTicketsIcon = "_8g-12";
export var noMoreTicketsSubText = "_8g-13";
export var oneLine = "_8g-l";
export var optionsButton = "_8g-n";
export var plus = "_8g-o";
export var portalButtonsWrapper = "_8g-g";
export var red = "_8g-p";
export var scrolledTop = "_8g-9";
export var search = "_8g-q";
export var selectedConversationsCount = "_8g-r";
export var spinner = "_8g-t";
export var strong = "_8g-u";
export var summaryCell = "_8g-v";
export var tableContainer = "_8g-11";
export var tagContainer = "_8g-w";
export var threeDots = "_8g-x";
export var twoLines = "_8g-y";
export var unread = "_8g-z";